import { setError, setSuccess, startLoading } from "../store/appSlice";
// import * as BanksFakeApi from "../fakeApi/banks";
import * as BanksApi from "../api/Banks";
import { callApi } from "./helpers/api";
import {
  fetchBank,
  fetchBanks,
  setBankActiveFlag,
  setBankBetaFlag,
  setItem,
  setPaginatedList,
  UpdateActionPayload,
  updateBank,
  updateItem,
} from "../store/bankSlice";
import { put, takeLatest, fork, takeEvery } from "redux-saga/effects";
import Bank from "../models/Bank";
import { UUID } from "../utils";
import { push } from "connected-react-router";

function* fetchBanksSaga(action: any) {
  const operationPath = ["banks", "list"];

  yield put(startLoading(operationPath));
  try {
    const { page = 0, limit, order, orderBy, search } = action.payload || {};

    const data = yield callApi(BanksApi.getBanks, {
      page,
      limit,
      order,
      orderBy,
      search,
    });
    yield put(setPaginatedList(data));

    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchBankSaga({
  payload,
}: {
  payload: {
    id: string;
  };
  type: string;
}) {
  const { id } = payload;
  const operationPath = ["banks", "items", id];
  yield put(startLoading(operationPath));

  try {
    const item = yield callApi(BanksApi.getBank, id);
    yield put(setItem({ id, item }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* updateBankSaga({
  payload,
}: {
  payload: UpdateActionPayload<Bank>;
  type: string;
}) {
  const { id, data, redirectOnSuccess = false, resolve } = payload;

  const operationPath = ["banks", "items", id];
  yield put(startLoading(operationPath));

  try {
    const bank = yield callApi(BanksApi.patchBank, id, data);
    yield put(setItem({ id, item: bank }));
    yield put(setSuccess(operationPath));
    if (redirectOnSuccess) {
      yield put(push(`/administration/banks/${bank.id}`));
    }
    if (resolve) {
      resolve();
    }
  } catch (error) {
    if (resolve) {
      resolve();
    }
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
    yield put(
      setError({
        path: ["banks", "items"],
        error,
      })
    );
  }
}

function* setBankActiveFlagSaga({
  payload,
}: {
  payload: { id: string; value: boolean };
  type: string;
}) {
  const { id, value } = payload;
  const operationPath = ["bank", "items", id, "setBankActiveFlag"];
  yield put(startLoading(operationPath));
  try {
    const bank = yield callApi(BanksApi.patchBank, id, {
      active: value,
    } as Bank);
    yield put(updateItem({ id, itemPart: { active: bank.active } }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* setBankBetaFlagSaga({
  payload,
}: {
  payload: { id: UUID; value: boolean };
  type: string;
}) {
  const { id, value } = payload;
  const operationPath = ["bank", "items", id, "setBankBetaFlag"];
  yield put(startLoading(operationPath));

  try {
    const bank = yield callApi(BanksApi.patchBank, id, {
      beta: value,
    } as Bank);
    yield put(updateItem({ id, itemPart: { beta: bank.beta } }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchBanks() {
  yield takeLatest(fetchBanks.type, fetchBanksSaga);
}
function* watchFetchBank() {
  yield takeLatest(fetchBank.type, fetchBankSaga);
}

function* watchUpdateBank() {
  yield takeLatest(updateBank.type, updateBankSaga);
}

function* watchBankActiveFlag() {
  yield takeEvery(setBankActiveFlag.type, setBankActiveFlagSaga);
}

function* watchBankBetaFlag() {
  yield takeEvery(setBankBetaFlag.type, setBankBetaFlagSaga);
}

export default function* rootSaga() {
  yield fork(watchFetchBanks);
  yield fork(watchFetchBank);
  yield fork(watchBankActiveFlag);
  yield fork(watchBankBetaFlag);
  yield fork(watchUpdateBank);
}
